import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from './redux/actions'
import * as dataMasterActions from '../car-data-master/redux/actions'
import {openModalFromSearchButton, openModalFromSidebar, clickSaveChanges, clickDiscardChanges, closeModal, updateUnsavedChanges} from '../precio-justo/redux/actions'
import ErrorBoundary from '../common/ErrorBoundary'
import { ThroughProvider } from 'react-through'
import Sidebar from 'react-sidebar'
import HeaderBar from './HeaderBar'
import SidebarContent from './SidebarContent'
import throttle from 'lodash/throttle'
import { REACT_APP_RV } from '../../common/config'
import { Helmet } from 'react-helmet'
import Snackbar from '@material-ui/core/Snackbar'
import Slide from '@material-ui/core/Slide'
import Paper from '@material-ui/core/Paper'
import { styled } from '@material-ui/core/styles'
import * as Colors from '../../common/colors'
import _ from 'lodash'
import axios from 'axios'
import { addMenuPresupuestoUltimoEditado, removeMenuPresupuestoUltimoEditado, comeFromSalesforce, getCustomFilters } from '../common/redux/actions'
import { clearFastStockLoading as stockClearFastStockLoading } from '../stock/redux/clearFastStockLoading/action'
import { clearCurrentTakingCar as stockClearCurrentTakingCar } from '../stock/redux/clearCurrentTakingCar/action'
import { clearDashboardSettings } from '../dashboard/redux/clearDashboardSettings'
import ModalUltimoEditado from '../presupuestador/ModalUltimoEditado'
import { getPresupuestoUltimoEditado, setPresupuestoAutomaticSave, setPresupuestoUltimoEditado, getPresupuestoAutomaticSave } from '../../common/BFF/BFF_presupuestador/ultimoPresupuestoEditado'
import { ESTADO } from '../presupuestador/MainPresupuestador.constants'
import { getCurrencySymbol } from '../common/redux/getCurrencySymbol'
import { getPlans } from '../common/redux/getPlans'
import { handleChangedSize } from '../common/redux/responsiveReducer'
import { swalAlert } from 'common/swalAlert'
import { titlesHtmlHead } from './titlesHtmlHead'
import { BFFAgent } from 'BFFAgent'
import { INTEGRATION_MELI_URL, INTEGRATION_MELI_URL_ACCOUNT_CREATION, INTEGRATION_MELI_IDENTIFIER } from '../../common/BFFUtils';
import ConfirmationModal from 'common/ConfirmationModal'
import { setIsAssignedTabAction } from '../leads/redux/setIsAssignedTab/action'
import { hideWhatsappCallingModal } from '../leads/redux/whatsappConversation/actions'
import { isMobile, isTablet } from 'react-device-detect'
import { TIMEZONE } from 'common/Constants'
import { appendAppVersionHeaders } from 'common/appVersionHeaders'
import { SocketContext  } from 'cfgCommon/socketContext'
import { REACT_APP_SESSION_EXPIRES_AT_IN_MINUTES } from 'cfgCommon/config'
import { WhatsAppCallModal } from '../leads/LeadEditor/WhatsappComponents/CallModal'

const TIMEOUT_MINUTES_PRE_WARNING = 2

const MELI_ERRORS_MESSAGE = {
  'access_denied': 'Error de conexión por falta de autorización.',
  'strict_redirect_uri_mismatch':'Error de conexión por error en la configuración de la uri.',
  'default': 'Error de conexión por falta de autorización'
}

const localStorageVersion = localStorage.getItem('version')
const integration_access = 'integration_access'
if (localStorageVersion) {
  if (localStorageVersion !== REACT_APP_RV) {
    localStorage.clear()
  }
} else {
  localStorage.setItem('version', REACT_APP_RV)
}

function TransitionDown(props) {
  return <Slide {...props} direction="down" />
}

const ServerDisonnectedNotice = styled(Paper)({
  backgroundColor: Colors.COLOR_DANGER_DARK,
  color: Colors.COLOR_TEXT_BLANCO,
  padding: '5px 6vw',
  fontSize: 20,
  borderRadius: 4,
  fontWeight: 600,
  userSelect: 'none',
})

const LogoutNotice = styled(Paper)({
  backgroundColor: Colors.COLOR_INFO,
  color: Colors.COLOR_TEXT_BLANCO,
  padding: '5px 6vw',
  fontSize: 20,
  borderRadius: 4,
  fontWeight: 600,
  userSelect: 'none',
})

export class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isMobile: null,
      isTabletPortrait: null,
      isTabletLandscape: null,
      sidebarCollapsed: false,
      token: null,
      open: false,
      isAlive: true,
      nextLocation: null,
      openUltimoEditadoModal: false,
      isAuthorizationInterceptorFinished: false,
      windowWidth: true,
      logoutWarning: false,
      forceCloseNotifications: false
    }
    
    this.toggleOpen = this.toggleOpen.bind(this)
    this.onSetOpen = this.onSetOpen.bind(this)
    this.toggleDock = this.toggleDock.bind(this)
    this._swipe_x = null
    this._swipe_y = null
    this._asofix_timeout_warn = undefined
    this._expirationInterval = undefined
  }

  static propTypes = {
    children: PropTypes.node,
  }

  static defaultProps = {
    children: '',
  }

  static contextType = SocketContext

  handleStorageChange = (e) => {
    if (e.key !== 'logged_until') {
      return
    }

    const loggedUntil = Number(e.newValue)

    if (!loggedUntil) {
      this.logout()
      return
    }

    if (Date.now() > loggedUntil) {
      this.logout()
      return
    }

    if (this.state.logoutWarning) {
      this.setState({ logoutWarning: false })
    }

    this.scheduleWarning()
  }

  scheduleWarning = () => {
    clearTimeout(this._asofix_timeout_warn)

    const loggedUntil = Number(localStorage.getItem('logged_until'))

    if (!loggedUntil) {
      return
    }

    const warningTime = loggedUntil - TIMEOUT_MINUTES_PRE_WARNING * 60 * 1000

    const timeout = warningTime - Date.now()

    if (timeout <= 0) {
      this.setState({ logoutWarning: true })
      return
    }

    this._asofix_timeout_warn = setTimeout(() => {
      this.setState({ logoutWarning: true })
    }, timeout)
  }

  resetLogoutTimer = () => {
    const loggedUntil = Date.now() + REACT_APP_SESSION_EXPIRES_AT_IN_MINUTES * 60 * 1000

    localStorage.setItem('logged_until', loggedUntil)

    if (this.state.logoutWarning) {
      this.setState({ logoutWarning: false })
    }

    this.scheduleWarning()
  }

  throttledResetLogoutTimer = throttle(this.resetLogoutTimer, 5000, {
    leading: true,
    trailing: false
  })

  onSetOpen(open) {
    this.setState({ open })
  }

  toggleDock() {
    this.setState({ docked: !this.state.docked })
  }

  toggleOpen(ev) {
    this.setState({ open: !this.state.open })
    if (ev) {
      ev.preventDefault()
    }
  }

  closeMenu = () => {
    this.setState({ open: false })
  }

  authorizationInterceptor = () => {
    const token = localStorage.getItem('token')

    if(!token) {
      console.error(`Falta token!!`)
      return this.logout()
    }

    return this.request_interceptor_id = axios.interceptors.request.use(
      request => {
        request.headers.Authorization = token
        request.headers.Pragma = 'no-cache'
        request.headers['Cache-Control'] = 'max-age=0'
        request.headers.Timezone = TIMEZONE
        appendAppVersionHeaders(request, this.props.user.isMobileSystem)
        return request
      },
      error => {
        return Promise.reject(error)
      },
    )
  }

  logout = () => {
    localStorage.removeItem('logged_until')
    this.props.history.push('/logout')
  }

  handleResize = () => {
    this.props.actions.handleChangedSize();
    this.setState({ isMobile: this.props.reduxState.common.isMobile})
    this.setState({ isTabletPortrait: this.props.reduxState.common.isTabletPortrait})
    this.setState({ isTabletLandscape: this.props.reduxState.common.isTabletLandscape})
  }

  componentDidMount() {
    document.addEventListener('keydown', this.throttledResetLogoutTimer)
    window.addEventListener('mousemove', this.throttledResetLogoutTimer)
    window.addEventListener('storage', this.handleStorageChange)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.setState({ isAuthorizationInterceptorFinished: this.authorizationInterceptor() })
    this.setState({ isMobile: isMobile })
    this.setState({ isTabletPortrait: isTablet })
    this.setState({ isAlive: true })

    const loggedUntil = Number(localStorage.getItem('logged_until'))

    if (!loggedUntil) {
      this.logout()
      return
    }

    if (Date.now() > loggedUntil) {
      this.logout()
      return
    }

    this.scheduleWarning()

    this._expirationInterval = setInterval(() => {
      const expiresAt = Number(localStorage.getItem('logged_until'))

      if (!expiresAt || Date.now() > expiresAt) {
        this.logout()
      }
    }, 1000)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.user.id !== this.props.user.id) {
      const ultimoPresupuesto = getPresupuestoUltimoEditado(this.props.user.id);
      if (ultimoPresupuesto) {
        this.props.actions.addMenuPresupuestoUltimoEditado();
      }
    }

    if (this.state.isAuthorizationInterceptorFinished !== prevState.isAuthorizationInterceptorFinished) {
      this.isFromSalesForce()
      this.checkIfReturnsFromMeli()
      this.props.actions.getBranchOffice()
      this.props.actions.loadSchemasFromMaestro()
      this.props.actions.loadSchemasFromCatalogo()
      this.props.actions.loadSchemasFromStock()
      this.props.actions.loadSchemaCategories()
      this.props.actions.getExchangeRates()
      this.props.actions.getCurrencySymbol()
      this.props.actions.getPlans()
      this.props.actions.getCustomFilters()
    }

    const saveChanges = this.props.precioJusto.modalConfirmationUsdData.saveChanges
    const discardChanges = this.props.precioJusto.modalConfirmationUsdData.discardChanges
    if (saveChanges || discardChanges) {
      const nextLocation = this.props.precioJusto.modalConfirmationUsdData.nextLocation
      if (nextLocation) {
        this.props.history.push(`/${nextLocation}`);
      }
      this.props.actions.closeModal()
    }

    if (!prevState.open && this.state.open) {
      this.forceCloseNotifications()
    }
  }

  onUltimoEditadoModalClick = (check) => {
    const userId = this.props.user.id;
    check && setPresupuestoAutomaticSave(userId, true);
    const options = { userId, nextLocation: this.state.nextLocation };
    this.saveUltimoPresupuestoAndMoveToNextLocation(options);
    this.closeUltimoEditadoModal();
  }

  closeUltimoEditadoModal = () => {
    this.setState({ openUltimoEditadoModal: false })
  }

  openUltimoEditadoModal = (nextLocation = '') => {
    this.setState({ openUltimoEditadoModal: true, nextLocation});
  }

  saveUltimoPresupuestoAndMoveToNextLocation = ({ nextLocation, userId }) => {
    const ultimoPresupuesto = getPresupuestoUltimoEditado(userId);
    if(!ultimoPresupuesto) {
      this.props.actions.addMenuPresupuestoUltimoEditado();
    }
    setPresupuestoUltimoEditado(userId, this.props.presupuestador)
    this.props.history.push(`/${nextLocation}`);
  }

  isFromSalesForce = () => {
    if(this.props.location.search.includes(`?${integration_access}=`)) {
      const search = new URLSearchParams(this.props.location.search)
      this.props.actions.comeFromSalesforce(search.get(integration_access))
      
      search.delete(integration_access)
      this.props.history.replace({ 
        search: search.toString(), 
      });   
    }
  }

  checkIfReturnsFromMeli = async () => {
    const pathArray =   window.location.pathname.split('/')
    const indexOfMeliIdentifier = pathArray.indexOf(INTEGRATION_MELI_IDENTIFIER)
    
    // Si no se encuentra el identificador se cancela el control
    if(indexOfMeliIdentifier === -1){
      return;
    }

    // El id de MeLi SIEMPRE es el siguiente valor despues del identificador
    const meliId = pathArray[indexOfMeliIdentifier + 1]

    const search = new URLSearchParams(this.props.location.search);

    let saveSuccess = false
    const error = search.get('error')
    if (error) {
        // Si hay un error en la uri se muestra el mensaje correspondiente
        // y se corta la ejecución
        this.props.actions.ErrorAction({
            title: MELI_ERRORS_MESSAGE[error] || MELI_ERRORS_MESSAGE['default']
        })
    } else {
        // Si hay codigo (se autorizo correctamente la app)
        // Se guarda el codigo de autenticacion
        const meliCode = search.get('code')
        if (meliCode) {
          saveSuccess = await BFFAgent.Integrations.saveMeliCode(meliId, meliCode)
        }
      }

    // Si no hay codigo (puede haber error)
    // Se redirecciona igualmente a la pantalla de canales de venta
    // Si traemos el error por validacion de clientSecret redireccionamos a la pantalla de creacion con los datos que corresponden.

    if(saveSuccess?.clientSecretError) {
      this.props.actions.ErrorAction({
        title: 'Error, el código enviado no es válido. Vuelva a conectar la cuenta nuevamente.'
      })
      this.redirectToAccountCreation(saveSuccess.config)
    }
    else if (saveSuccess?.error_user_id) {
      this.props.actions.ErrorAction({
        title: 'La cuenta con la que estás logueado en Mercado Libre no se corresponde con la cuenta a reactivar.'
      })
      this.redirectToIntegrations()
    }
    else if (saveSuccess?.error_company_id) {
      this.props.actions.ErrorAction({
        title: 'La cuenta que se quiere reactivar no coincide la empresa con la que se activó.'
      })

      this.redirectToIntegrations()
    }
    else {
      this.props.actions.SuccessAction({
        title: saveSuccess.message
      })
      this.redirectToMeli(saveSuccess)
    }
  }

  redirectToIntegrations = () => {
      this.props.history.push(INTEGRATION_MELI_URL)
  }
  
  redirectToMeli = saveSuccess => {
    const {updatedAccount, integration} = saveSuccess
    if (saveSuccess) {
      this.props.history.push(
        `${INTEGRATION_MELI_URL}/${integration?.title}/${updatedAccount?.config?.name}/${updatedAccount?.id}`,
        {
          ...updatedAccount, 
          breadcrumbs: { [updatedAccount.id]: `${integration.title} / ${updatedAccount.config.name}` }, 
          logo: integration.logo}
      );
    } else {
      this.props.history.push(INTEGRATION_MELI_URL)
    }
  }
  redirectToAccountCreation = ({ client_id, client_secret, redirect_uri }) => {
    this.props.history.push({
      pathname: INTEGRATION_MELI_URL_ACCOUNT_CREATION,
      state: { clientSecretError: true, client_id, client_secret, redirect_uri }
    });
  } 

  handlePresupuestadorLocationChange = nextLocation => {
    const canSavePresupuesto =
      (this.props.presupuestador.nuevo ||
      this.props.presupuestador.cliente?.cliente_id ||
      this.props.presupuestador.entregaUsados.length) &&
      (this.props.presupuestador.state === ESTADO.BORRADOR ||
      this.props.presupuestador.state === ESTADO.GENERADO);

    if(canSavePresupuesto) {
      const userId = this.props.user.id;
      const hasAutomaticSaveActive = getPresupuestoAutomaticSave(userId);
      if(hasAutomaticSaveActive) {
        this.setState({nextLocation});
        const options = { nextLocation, userId }
        this.saveUltimoPresupuestoAndMoveToNextLocation(options);
      } else {
      this.openUltimoEditadoModal(nextLocation)
      }
    } else {
      this.props.history.push(`/${nextLocation}`);
    }
  }

  handleFastStockLoadingLocationChange = nextLocation => {
    if(this.props.stockFastStockLoading.savedForm){
      if(!nextLocation.includes('stock/gestion-de-usados')){
        this.props.actions.stockClearFastStockLoading()
        this.props.actions.stockClearCurrentTakingCar()
      }
      this.props.history.push(`/${nextLocation}`);
    } else {
      const defaultOptions = {
        title: '',
        text: 'Estas por salir sin guardar los cambios. ¿Queres salir igual?',
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: 'Volver',
        confirmButtonText: 'Salir',
        customClass: {
          container: 'fast-stock-loading-alert'
        }
      }
      swalAlert(defaultOptions).then(result => {
        if(result.isConfirmed){
          if(!nextLocation.includes('stock/gestion-de-usados')){
            this.props.actions.stockClearFastStockLoading()
            this.props.actions.stockClearCurrentTakingCar()
          }
          this.props.history.push(`/${nextLocation}`);
        }
      })
    }
  }

  handleDashboardLocationChange = nextLocation => {
      if(!nextLocation.includes('dashboard')) this.props.actions.clearDashboardSettings()
      this.props.history.push(`/${nextLocation}`);
  }

  handlePrecioJustoLocationChange = nextLocation => {
    if (this.props.precioJusto.unsavedChanges) {
      this.props.actions.openModalFromSidebar(nextLocation)
    } else {
      this.props.history.push(`/${nextLocation}`);
    }
  }

  handleGestorLeadsdLocationChange = nextLocation => {
    if(this.props.location.pathname !== `/${nextLocation}`) {
      this.props.history.push(`/${nextLocation}`);
      this.props.actions.setIsAssignedTabAction(false)
    } 
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.throttledResetLogoutTimer)
    window.removeEventListener('mousemove', this.throttledResetLogoutTimer)
    window.removeEventListener('storage', this.handleStorageChange)
    window.removeEventListener('resize', this.handleResize)
    this.setState({ isAlive: false })
    clearTimeout(this._asofix_timeout_warn)
    clearInterval(this._expirationInterval)
    this.throttledResetLogoutTimer.cancel()
    axios.interceptors.response.eject(this.interceptor_id)
    axios.interceptors.request.eject(this.request_interceptor_id)
  }

  toggleCollapse = () => {
    if (this.state.isMobile || this.state.isTabletPortrait) {
      this.setState({ open: !this.state.open })
    } else {
      this.setState({ sidebarCollapsed: !this.state.sidebarCollapsed })
    }
  }
  
  expandSidebar = () => {
    this.setState({ sidebarCollapsed: false})
  }

  onTouchStart = event => {
    this._swipe_x = event.touches[0].clientX
    this._swipe_y = event.touches[0].clientY
    this._is_swipping = true
  }

  onTouchMove = _.throttle(e => {
    if (
      this._is_swipping &&
      e.changedTouches &&
      e.changedTouches.length &&
      this.state.isMobile &&
      !this.state.open
    ) {
      if (
        e.changedTouches[0].clientY - this._swipe_y > 50 ||
        e.changedTouches[0].clientY - this._swipe_y < -50
      ) {
        this._is_swipping = false
      } else if (e.changedTouches[0].clientX - this._swipe_x > 100) {
        this._is_swipping = false
        this.setState({ open: true })
      }
    }
  }, 20)
  
  handleDiscardChanges = () => {
    this.props.actions.clickDiscardChanges()
    this.props.actions.updateUnsavedChanges(false)
  }
  handleSaveChanges = () => {
    this.props.actions.clickSaveChanges()
    this.props.actions.updateUnsavedChanges(false)
  }

  forceCloseNotifications = () => {
    this.setState({
      forceCloseNotifications: true
    })
  }

  setForceCloseNotificationsFalse = () => {
    this.setState({
      forceCloseNotifications: false
    })
  }
  render() {
    const sidebar = (
      <SidebarContent
        closeMenu={this.closeMenu}
        expandSidebar={this.expandSidebar}
        isMobile={this.state.isMobile || this.state.isTabletPortrait}
        sidebarCollapsed={this.state.sidebarCollapsed}
        user={this.props.user}
        location={this.props.location}
        onPresupuestadorLocationChange={this.handlePresupuestadorLocationChange}
        onFastStockLoadingLocationChange={this.handleFastStockLoadingLocationChange}
        onDashboardLocationChange={this.handleDashboardLocationChange}
        onPrecioJustoLocationChange={this.handlePrecioJustoLocationChange}
        handleGestorLeadsdLocationChange={this.handleGestorLeadsdLocationChange}
        history={this.props.history}
        removeMenuPresupuestoUltimoEditado={this.props.actions.removeMenuPresupuestoUltimoEditado}
        hasPayment={this.props.hasPayment}
      />
    )
    const sidebarProps = {
      sidebar,
      docked: !(this.state.isMobile || this.state.isTabletPortrait),
      touch: this.state.isMobile || this.state.isTabletPortrait,
      open: this.state.open,
      shadow: false,
      onSetOpen: this.onSetOpen,
      styles: {
        sidebar: {
          zIndex: this.state.isMobile ? 3001 : 11,
          top: this.state.isMobile ? '0px' : '4.5rem',
          paddingTop: this.state.isMobile ? 'env(safe-area-inset-top)' : '0px',
          borderRadius: this.state.isMobile ? '0px 10px 10px 0px' : null,
        },
        overlay: {
          zIndex: 10,
          top: this.state.isMobile ? '0px' : '4.5rem',
        },
        dragHandle: {
          zIndex: 10,
        },
      },
      touchHandleWidth: 0,
    }

    let pathname = this.props.location.pathname
    if(pathname.includes("/catalogo/carDetail/")) {
      // add all pathname with id ||
      const strs = this.props.location.pathname.split('/');
      const id = strs.at(-1)
      pathname = pathname.replace(`/${id}`, "")
    }

    return (
      <ErrorBoundary logout>
        <Helmet>
          <title>{titlesHtmlHead[pathname] || "Asofix"}</title>
        </Helmet>
        
        <ThroughProvider>
          <Sidebar {...sidebarProps}>
            <HeaderBar
              toggleOpen={this.toggleOpen}
              closeMenu={this.closeMenu}
              forceCloseNotificationsFlag={this.state.forceCloseNotifications}
              forceCloseNotifications={this.forceCloseNotifications}
              setForceCloseNotificationsFalse={this.setForceCloseNotificationsFalse}
              sidebarCollapsed={this.state.sidebarCollapsed}
              isMobile={this.state.isMobile}
              toggleCollapse={this.toggleCollapse}
              hasSirenaKey={this.props.hasSirenaKey}
            >
              <div className="master-content">{this.props.children}</div>
            </HeaderBar>
          </Sidebar>
        </ThroughProvider>
        {
          this.props.showWhatsappCalling && (
            <WhatsAppCallModal
              companyId={this.props.companyId}
              isOpen={this.props.showWhatsappCalling}
              onClose={this.props.actions.hideWhatsappCallingModal}
            />
          )
        }
        <ModalUltimoEditado
          stateOpen={this.state.openUltimoEditadoModal}
          closeModal={this.closeUltimoEditadoModal}
          onClick={this.onUltimoEditadoModalClick}
        />
        {this.props.precioJusto.modalConfirmationUsdData.isOpen &&
          <ConfirmationModal
          title="¿Querés guardar los cambios?"
          onClose={()=>this.props.actions.closeModal()}
          confirmLabel="GUARDAR CAMBIOS"
          cancelLabel="DESCARTAR CAMBIOS"
          onCancel={this.handleDiscardChanges}
          onConfirm={this.handleSaveChanges}
          className={'modal-text-exchange-rate'}
          >
            <div>Encontramos cambios sin guardar en el valor de cotización.</div>
          </ConfirmationModal>
        }
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={!this.state.isAlive}
          TransitionComponent={TransitionDown}
        >
          <ServerDisonnectedNotice elevation={4}>
            El servidor no responde
          </ServerDisonnectedNotice>
        </Snackbar>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.logoutWarning}
          TransitionComponent={TransitionDown}
        >
          <LogoutNotice elevation={4}>
            El sistema se va a desloguear
          </LogoutNotice>
        </Snackbar>
      </ErrorBoundary>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.common.user,
    reduxState: state,
    presupuestador: state.presupuestador,
    stockFastStockLoading: state.stock.takingCarManagement.fastStockLoading,
    branchOffices: state.common.branchOffices,
    hasPayment: state?.common?.user?.license?.hasPayment || false,
    hasSirenaKey: state.common.user?.license?.hasSirenaKey,
    companyId: state?.common?.user?.license?.company?.id || '',
    showWhatsappCalling: state.leads?.whatsapp?.show_calling_modal || false,
    precioJusto: state.precioJusto
  }
}
/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...actions,
      addMenuPresupuestoUltimoEditado,
      ...dataMasterActions,
      stockClearFastStockLoading,
      stockClearCurrentTakingCar,
      clearDashboardSettings,
      getCurrencySymbol,
      getPlans,
      removeMenuPresupuestoUltimoEditado,
      handleChangedSize,
      comeFromSalesforce,
      openModalFromSearchButton,
      openModalFromSidebar,
      clickSaveChanges,
      clickDiscardChanges,
      closeModal,
      updateUnsavedChanges,
      setIsAssignedTabAction,
      hideWhatsappCallingModal,
      getCustomFilters
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
